import styled from 'styled-components'
import fonts from '../../const/fonts'
import { H2 } from '../../typography'

export const SectionTitle = styled(H2)`
  @media (max-width: 415px) {
    font-size: ${fonts.medium}px;
  }
`

export const SubHeaderContainer = styled.div`
  display: flex;
  margin: 24px 0;
  height: 75px;
  width: 100%;
`

export const SubjectInfo = styled.div`
  margin: auto 0;
`

export const ContentWrapper = styled.div`
  display: flex;
`

export const SubHeaderWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`

export const DropdownWrapper = styled.div`
  margin: auto 0;
  @media (max-width: 415px) {
    width: 35%;
  }
`
